/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  VERIFY_OTP: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.verify.otp',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'VERIFY_OTP' },
      },
    },
    VERIFY_OTP: {
      invoke: {
        id: 'verifyOTP',
        src: 'verifyOTP',
        onDone: {
          target: 'VERIFY_OTP_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'VERIFY_OTP_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    VERIFY_OTP_SUCCESS: {
      on: {
        START: { target: 'VERIFY_OTP' },
      },
    },
    VERIFY_OTP_FAILED: {
      on: {
        START: { target: 'VERIFY_OTP' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
